export class BaseClient {
    protected async fetchWithAuth(url: string, options: RequestInit = {}): Promise<Response> {
        const token = localStorage.getItem('authToken');
        const headers = new Headers(options.headers);

        if (token) {
            headers.set('Authorization', `Bearer ${token}`);
        }

        if (!headers.has('Content-Type') &&
            (options.method === 'POST' || options.method === 'PUT' || options.method === 'PATCH')) {
            headers.set('Content-Type', 'application/json');
        }

        const config = {
            ...options,
            headers,
        };

        const response = await fetch(url, config);

        if (response.status === 401) {
            window.dispatchEvent(new CustomEvent('auth:unauthorized'));
        }

        return response;
    }
}
